import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/styles/index.scss";
import "@/plugins/firebase";

createApp(App).use(router).mount("#app");
